<template>
  <div class="partner-container">
    <div class="partner-content">
      <div class="partner-header">
        <h2 class="partner-title">合作伙伴<span style="color: #F66F00;">•</span></h2>
        <p class="partner-subtitle">PARTNER</p>
      </div>
      
      <div class="partner-grid">
        <div class="partner-item"  v-for="item in partnerList" :key="item.id" @click="handleClick(item)">
            <img class="partner-logo" :src="httphosts + item.image" alt="">
            <div class="partner-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { partner } from '@/api/index'
import { httphosts } from '@/utils/global'

export default {
  name: 'Partner',
  data() {
    return {
      httphosts: httphosts,
      // 可以在这里添加数据
      partnerList: []
    }
  },
  mounted() {
    this.getPartnerList()
  },
  watch: {
    '$route': {
      handler() {
        // 当路由变化时，重新加载数据
        this.getPartnerList()
      }
    }
  },
  methods: {
    // 可以在这里添加方法
    getPartnerList() {
      partner().then(res => {
        if (res.code === 1) {
          this.partnerList = res.data
        }
      })
    },
    handleClick(item) {
      window.open(item.href, '_blank')
    }
  }
}
</script>

<style scoped>
.partner-container {
  padding: 60px 0;
  /* background: #fff; */
  width: 100%;
}

.partner-content {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

.partner-header {
  text-align: center;
  margin-bottom: 40px;
}

.partner-title {
  font-size: 30px;
  color: #1B5AFF;
  margin-bottom: 8px;
  font-weight: bold;
  line-height: 30px;

}

.partner-subtitle {
  font-size: 24px;
  color: #DDE4EA;
  margin: 0;
}

.partner-grid {
  display: grid;
  /* grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); */
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.partner-item {
  background: #fff;
  border-radius: 10px;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* flex-wrap: wrap; */
  /* gap: 10px; */
  transition: all 0.3s;
  transition: transform 0.3s ease;
}

.partner-item:hover {
  transform: scale(1.1);
}

@keyframes pulse {
  0% {
    transform: translateY(-2px);
  }
  50% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(-2px);
  }
}

.partner-logo {
  max-width: 368px;
  max-height: 174px;
  object-fit: fill;
  transition: transform 0.3s ease;
}

/* .partner-logo:hover {
  transform: scale(1.1);
} */
.partner-name {
  font-size: 16px;
  /* color: #1B5AFF; */
  /* margin-top: 12px; */
}

/* 响应式设计 */
@media (max-width: 768px) {
  .partner-container {
    padding: 40px 0;
  }
  
  .partner-header {
    margin-bottom: 30px;
  }
  
  .partner-title {
    font-size: 20px;
  }
  
  .partner-grid {
    /* display: grid; */
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    /* grid-template-columns: repeat(4, 1fr); */
    gap: 20px;
  }
  
  .partner-item {
    padding: 20px;
  }
}
</style>